export default __webpack_public_path__ + "static/media/P730_RoHS.dafe9e12.pdf";